import gql from 'graphql-tag';

export const fields = `
    tenantIds
    fleetId
    fleet {
        id
        tenantIds
        hasOpenIssues
        hasAiPredictions
        hasSchedule
    }
    aircraftModelId
    aircraftModel {
        id
        name
        totalMotors
        aircraftStatuses {
            id
            name
        }
    }
    plate
    serialNumber
    statusId
    status {
        id
        name
    }
    engine1 {
        engineFlyingHours
    }
    engine1Id
    engine1SerialNumber
    engine2 {
        engineFlyingHours
    }
    engine2Id
    engine2SerialNumber
    engine3 {
        engineFlyingHours
    }
    engine3Id
    engine3SerialNumber
    engine4 {
        engineFlyingHours
    }
    engine4Id
    engine4SerialNumber
    meta
    createdAt
    updatedAt
`;

export const relationsFields = `
    digitaiGetAircraftStatuses (
        query: $queryAircraftStatuses
        constraint: $constraintAircraftStatuses
    ) {
        id
        name
    }
`;

// default methods
export const paginationQuery = gql`
    query DigitaiPaginateFleetAircrafts (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        pagination: digitaiPaginateFleetAircrafts (
            query: $query
            constraint: $constraint
        ) {
            total
            rows
            count
        }
    }
`;

export const getQuery = gql`
    query DigitaiGetFleetAircrafts (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        objects: digitaiGetFleetAircrafts (
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const getRelations = gql`
    query DigitaiGetFleetAircraftsRelations (
        $queryAircraftStatuses: QueryStatement
        $constraintAircraftStatuses: QueryStatement
    ) {
        ${relationsFields}
    }
`;

export const findByIdQuery = gql`
    query DigitaiFindFleetAircraftById (
        $id: ID
        $constraint: QueryStatement
    ) {
        object: digitaiFindFleetAircraftById (
            id: $id
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const findByIdWithRelationsQuery = gql`
    query DigitaiFindFleetAircraftByIdWithRelations (
        $id: ID
        $constraint: QueryStatement
        $queryAircraftStatuses: QueryStatement
        $constraintAircraftStatuses: QueryStatement
        $queryPaginateFleetAircraftEngines: QueryStatement
        $constraintPaginateFleetAircraftEngines: QueryStatement
    ) {
        object: digitaiFindFleetAircraftById (
            id: $id
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
        digitaiPaginateFleetAircraftEngines (
            query: $queryPaginateFleetAircraftEngines
            constraint: $constraintPaginateFleetAircraftEngines
        ) {
            total
            rows
            count
        }
        ${relationsFields}
    }
`;

export const findQuery = gql`
    query DigitaiFindFleetAircraft (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        object: digitaiFindFleetAircraft (
            query: $query
            constraint: $constraint
        ) {
            id
            #FIELDS
        }
    }
`;

export const createMutation = gql`
    mutation DigitaiCreateFleetAircraft (
        $payload: DigitaiCreateFleetAircraftInput!
    ) {
        digitaiCreateFleetAircraft (
            payload: $payload
        ) {
            ${fields}
        }
    }
`;

export const insertMutation = gql`
    mutation DigitaiCreateFleetAircrafts (
        $payload: [DigitaiCreateFleetAircraftInput]!
    ) {
        digitaiCreateFleetAircrafts (
            payload: $payload
        )
    }
`;

export const updateByIdMutation = gql`
    mutation DigitaiUpdateFleetAircraftById (
        $payload: DigitaiUpdateFleetAircraftByIdInput!
        $constraint: QueryStatement
    ) {
        digitaiUpdateFleetAircraftById (
            payload: $payload
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const updateMutation = gql`
    mutation DigitaiUpdateFleetAircrafts (
        $payload: DigitaiUpdateFleetAircraftsInput!
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiUpdateFleetAircrafts (
            payload: $payload
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteByIdMutation = gql`
    mutation DigitaiDeleteFleetAircraftById (
        $id: ID!
        $constraint: QueryStatement
    ) {
        digitaiDeleteFleetAircraftById (
            id: $id
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;

export const deleteMutation = gql`
    mutation DigitaiDeleteFleetAircrafts (
        $query: QueryStatement
        $constraint: QueryStatement
    ) {
        digitaiDeleteFleetAircrafts (
            query: $query
            constraint: $constraint
        ) {
            ${fields}
        }
    }
`;
